export default __webpack_public_path__ + "static/media/2-Travesuras del la Nina - Rocio Lopez.9ac16c68.jpg";